export interface ISpecMessages {
    ComponentID: number;
    MsgType: string;
    Name: string;
    CategoryID: string;
    SectionID: string;
    Description: string;
    AbbrName: string;
    NotReqXML: number;
    added: string;
    addedEP?: number;
    updated?: string;
    updatedEP?: number;
}

export const MESSAGES: ISpecMessages[] = [
    {
        CategoryID: 'Session',
        Description:
            'The Heartbeat monitors the status of the communication link and identifies when the last of a string of messages was not received.',
        added: 'FIX.2.7',
        AbbrName: 'Heartbeat',
        MsgType: '0',
        NotReqXML: 1,
        ComponentID: 1,
        SectionID: 'Session',
        Name: 'Heartbeat',
    },
    {
        CategoryID: 'Session',
        Description:
            'The test request message forces a heartbeat from the opposing application. The test request message checks sequence numbers or verifies communication line status. The opposite application responds to the Test Request with a Heartbeat containing the TestReqID.',
        added: 'FIX.2.7',
        AbbrName: 'TestRequest',
        MsgType: '1',
        NotReqXML: 1,
        ComponentID: 2,
        SectionID: 'Session',
        Name: 'TestRequest',
    },
    {
        CategoryID: 'Session',
        Description:
            'The resend request is sent by the receiving application to initiate the retransmission of messages. This function is utilized if a sequence number gap is detected, if the receiving application lost a message, or as a function of the initialization process.',
        added: 'FIX.2.7',
        AbbrName: 'ResendRequest',
        MsgType: '2',
        NotReqXML: 1,
        ComponentID: 3,
        SectionID: 'Session',
        Name: 'ResendRequest',
    },
    {
        CategoryID: 'Session',
        Description:
            'The reject message should be issued when a message is received but cannot be properly processed due to a session-level rule violation. An example of when a reject may be appropriate would be the receipt of a message with invalid basic data which successfully passes de-encryption, CheckSum and BodyLength checks.',
        added: 'FIX.2.7',
        AbbrName: 'Reject',
        MsgType: '3',
        NotReqXML: 1,
        ComponentID: 4,
        SectionID: 'Session',
        Name: 'Reject',
    },
    {
        CategoryID: 'Session',
        Description:
            'The sequence reset message is used by the sending application to reset the incoming sequence number on the opposing side.',
        added: 'FIX.2.7',
        AbbrName: 'SequenceReset',
        MsgType: '4',
        NotReqXML: 1,
        ComponentID: 5,
        SectionID: 'Session',
        Name: 'SequenceReset',
    },
    {
        CategoryID: 'Session',
        Description:
            'The logout message initiates or confirms the termination of a FIX session. Disconnection without the exchange of logout messages should be interpreted as an abnormal condition.',
        added: 'FIX.2.7',
        AbbrName: 'Logout',
        MsgType: '5',
        NotReqXML: 1,
        ComponentID: 6,
        SectionID: 'Session',
        Name: 'Logout',
    },
    {
        CategoryID: 'Indication',
        Description:
            'Indication of interest messages are used to market merchandise which the broker is buying or selling in either a proprietary or agency capacity. The indications can be time bound with a specific expiration value. Indications are distributed with the understanding that other firms may react to the message first and that the merchandise may no longer be available due to prior trade.\nIndication messages can be transmitted in various transaction types; NEW, CANCEL, and REPLACE. All message types other than NEW modify the state of the message identified in IOIRefID.',
        added: 'FIX.2.7',
        AbbrName: 'IOI',
        MsgType: '6',
        NotReqXML: 0,
        ComponentID: 7,
        SectionID: 'PreTrade',
        Name: 'IOI',
    },
    {
        CategoryID: 'Indication',
        Description:
            'Advertisement messages are used to announce completed transactions. The advertisement message can be transmitted in various transaction types; NEW, CANCEL and REPLACE. All message types other than NEW modify the state of a previously transmitted advertisement identified in AdvRefID.',
        added: 'FIX.2.7',
        AbbrName: 'Adv',
        MsgType: '7',
        NotReqXML: 0,
        ComponentID: 8,
        SectionID: 'PreTrade',
        Name: 'Advertisement',
    },
    {
        CategoryID: 'SingleGeneralOrderHandling',
        Description:
            'The execution report message is used to:\n1. confirm the receipt of an order\n2. confirm changes to an existing order (i.e. accept cancel and replace requests)\n3. relay order status information\n4. relay fill information on working orders\n5. relay fill information on tradeable or restricted tradeable quotes\n6. reject orders\n7. report post-trade fees calculations associated with a trade',
        added: 'FIX.2.7',
        AbbrName: 'ExecRpt',
        MsgType: '8',
        NotReqXML: 0,
        ComponentID: 9,
        SectionID: 'Trade',
        Name: 'ExecutionReport',
    },
    {
        CategoryID: 'SingleGeneralOrderHandling',
        Description:
            'The order cancel reject message is issued by the broker upon receipt of a cancel request or cancel/replace request message which cannot be honored.',
        added: 'FIX.2.7',
        AbbrName: 'OrdCxlRej',
        MsgType: '9',
        NotReqXML: 0,
        ComponentID: 10,
        SectionID: 'Trade',
        Name: 'OrderCancelReject',
    },
    {
        CategoryID: 'Session',
        Description:
            'The logon message authenticates a user establishing a connection to a remote system. The logon message must be the first message sent by the application requesting to initiate a FIX session.',
        added: 'FIX.2.7',
        AbbrName: 'Logon',
        MsgType: 'A',
        NotReqXML: 1,
        ComponentID: 11,
        SectionID: 'Session',
        Name: 'Logon',
    },
    {
        CategoryID: 'EventCommunication',
        Description:
            "The news message is a general free format message between the broker and institution. The message contains flags to identify the news item's urgency and to allow sorting by subject company (symbol). The News message can be originated at either the broker or institution side, or exchanges and other marketplace venues.",
        added: 'FIX.2.7',
        AbbrName: 'News',
        MsgType: 'B',
        NotReqXML: 0,
        ComponentID: 12,
        SectionID: 'PreTrade',
        Name: 'News',
    },
    {
        CategoryID: 'EventCommunication',
        Description:
            'The email message is similar to the format and purpose of the News message, however, it is intended for private use between two parties.',
        added: 'FIX.2.7',
        AbbrName: 'Email',
        MsgType: 'C',
        NotReqXML: 0,
        ComponentID: 13,
        SectionID: 'PreTrade',
        Name: 'Email',
    },
    {
        CategoryID: 'SingleGeneralOrderHandling',
        Description:
            'The new order message type is used by institutions wishing to electronically submit securities and forex orders to a broker for execution.\nThe New Order message type may also be used by institutions or retail intermediaries wishing to electronically submit Collective Investment Vehicle (CIV) orders to a broker or fund manager for execution.',
        added: 'FIX.2.7',
        AbbrName: 'Order',
        MsgType: 'D',
        NotReqXML: 0,
        ComponentID: 14,
        SectionID: 'Trade',
        Name: 'NewOrderSingle',
    },
    {
        CategoryID: 'ProgramTrading',
        Description:
            'The NewOrderList Message can be used in one of two ways depending on which market conventions are being followed.',
        added: 'FIX.2.7',
        AbbrName: 'NewOrdList',
        MsgType: 'E',
        NotReqXML: 0,
        ComponentID: 15,
        SectionID: 'Trade',
        Name: 'NewOrderList',
    },
    {
        CategoryID: 'SingleGeneralOrderHandling',
        Description:
            'The order cancel request message requests the cancellation of all of the remaining quantity of an existing order. Note that the Order Cancel/Replace Request should be used to partially cancel (reduce) an order).',
        added: 'FIX.2.7',
        AbbrName: 'OrdCxlReq',
        MsgType: 'F',
        NotReqXML: 0,
        ComponentID: 16,
        SectionID: 'Trade',
        Name: 'OrderCancelRequest',
    },
    {
        CategoryID: 'SingleGeneralOrderHandling',
        Description:
            'The order cancel/replace request is used to change the parameters of an existing order.\nDo not use this message to cancel the remaining quantity of an outstanding order, use the Order Cancel Request message for this purpose.',
        added: 'FIX.2.7',
        AbbrName: 'OrdCxlRplcReq',
        MsgType: 'G',
        NotReqXML: 0,
        ComponentID: 17,
        SectionID: 'Trade',
        Name: 'OrderCancelReplaceRequest',
    },
    {
        CategoryID: 'SingleGeneralOrderHandling',
        Description:
            'The order status request message is used by the institution to generate an order status message back from the broker.',
        added: 'FIX.2.7',
        AbbrName: 'OrdStatReq',
        MsgType: 'H',
        NotReqXML: 0,
        ComponentID: 18,
        SectionID: 'Trade',
        Name: 'OrderStatusRequest',
    },
    {
        CategoryID: 'Allocation',
        Description:
            'The Allocation Instruction message provides the ability to specify how an order or set of orders should be subdivided amongst one or more accounts. In versions of FIX prior to version 4.4, this same message was known as the Allocation message. Note in versions of FIX prior to version 4.4, the allocation message was also used to communicate fee and expense details from the Sellside to the Buyside. This role has now been removed from the Allocation Instruction and is now performed by the new (to version 4.4) Allocation Report and Confirmation messages.,The Allocation Report message should be used for the Sell-side Initiated Allocation role as defined in previous versions of the protocol.',
        added: 'FIX.2.7',
        AbbrName: 'AllocInstrctn',
        MsgType: 'J',
        NotReqXML: 0,
        ComponentID: 19,
        SectionID: 'PostTrade',
        Name: 'AllocationInstruction',
    },
    {
        CategoryID: 'ProgramTrading',
        Description:
            'The List Cancel Request message type is used by institutions wishing to cancel previously submitted lists either before or during execution.',
        added: 'FIX.2.7',
        AbbrName: 'ListCxlReq',
        MsgType: 'K',
        NotReqXML: 0,
        ComponentID: 20,
        SectionID: 'Trade',
        Name: 'ListCancelRequest',
    },
    {
        CategoryID: 'ProgramTrading',
        Description:
            'The List Execute message type is used by institutions to instruct the broker to begin execution of a previously submitted list. This message may or may not be used, as it may be mirroring a phone conversation.',
        added: 'FIX.2.7',
        AbbrName: 'ListExct',
        MsgType: 'L',
        NotReqXML: 0,
        ComponentID: 21,
        SectionID: 'Trade',
        Name: 'ListExecute',
    },
    {
        CategoryID: 'ProgramTrading',
        Description:
            'The list status request message type is used by institutions to instruct the broker to generate status messages for a list.',
        added: 'FIX.2.7',
        AbbrName: 'ListStatReq',
        MsgType: 'M',
        NotReqXML: 0,
        ComponentID: 22,
        SectionID: 'Trade',
        Name: 'ListStatusRequest',
    },
    {
        CategoryID: 'ProgramTrading',
        Description:
            "The list status message is issued as the response to a List Status Request message sent in an unsolicited fashion by the sell-side. It indicates the current state of the orders within the list as they exist at the broker's site. This message may also be used to respond to the List Cancel Request.",
        added: 'FIX.2.7',
        AbbrName: 'ListStat',
        MsgType: 'N',
        NotReqXML: 0,
        ComponentID: 23,
        SectionID: 'Trade',
        Name: 'ListStatus',
    },
    {
        CategoryID: 'Allocation',
        Description:
            'In versions of FIX prior to version 4.4, this message was known as the Allocation ACK message.\nThe Allocation Instruction Ack message is used to acknowledge the receipt of and provide status for an Allocation Instruction message.',
        added: 'FIX.2.7',
        AbbrName: 'AllocInstrctnAck',
        MsgType: 'P',
        NotReqXML: 0,
        ComponentID: 24,
        SectionID: 'PostTrade',
        Name: 'AllocationInstructionAck',
    },
    {
        CategoryID: 'SingleGeneralOrderHandling',
        Description:
            'The Don’t Know Trade (DK) message notifies a trading partner that an electronically received execution has been rejected. This message can be thought of as an execution reject message.',
        added: 'FIX.4.0',
        AbbrName: 'DkTrd',
        MsgType: 'Q',
        NotReqXML: 0,
        ComponentID: 25,
        SectionID: 'Trade',
        Name: 'DontKnowTrade',
    },
    {
        CategoryID: 'QuotationNegotiation',
        Description:
            'In some markets it is the practice to request quotes from brokers prior to placement of an order. The quote request message is used for this purpose. This message is commonly referred to as an Request For Quote (RFQ)',
        added: 'FIX.4.0',
        AbbrName: 'QuotReq',
        MsgType: 'R',
        NotReqXML: 0,
        ComponentID: 26,
        SectionID: 'PreTrade',
        Name: 'QuoteRequest',
    },
    {
        CategoryID: 'QuotationNegotiation',
        Description:
            'The Quote message is used as the response to a Quote Request or a Quote Response message in both indicative, tradeable, and restricted tradeable quoting markets.',
        added: 'FIX.4.0',
        AbbrName: 'Quot',
        MsgType: 'S',
        NotReqXML: 0,
        ComponentID: 27,
        SectionID: 'PreTrade',
        Name: 'Quote',
    },
    {
        CategoryID: 'SettlementInstruction',
        Description:
            'The Settlement Instructions message provides the broker’s, the institution’s, or the intermediary’s instructions for trade settlement. This message has been designed so that it can be sent from the broker to the institution, from the institution to the broker, or from either to an independent "standing instructions" database or matching system or, for CIV, from an intermediary to a fund manager.',
        added: 'FIX.4.1',
        AbbrName: 'SettlInstrctns',
        MsgType: 'T',
        NotReqXML: 0,
        ComponentID: 28,
        SectionID: 'PostTrade',
        Name: 'SettlementInstructions',
    },
    {
        CategoryID: 'MarketData',
        Description:
            'Some systems allow the transmission of real-time quote, order, trade, trade volume, open interest, and/or other price information on a subscription basis. A Market Data Request is a general request for market data on specific securities or forex quotes.',
        added: 'FIX.4.2',
        AbbrName: 'MktDataReq',
        MsgType: 'V',
        NotReqXML: 0,
        ComponentID: 29,
        SectionID: 'PreTrade',
        Name: 'MarketDataRequest',
    },
    {
        CategoryID: 'MarketData',
        Description:
            'The Market Data messages are used as the response to a Market Data Request message. In all cases, one Market Data message refers only to one Market Data Request. It can be used to transmit a 2-sided book of orders or list of quotes, a list of trades, index values, opening, closing, settlement, high, low, or VWAP prices, the trade volume or open interest for a security, or any combination of these.',
        added: 'FIX.4.2',
        AbbrName: 'MktDataFull',
        MsgType: 'W',
        NotReqXML: 0,
        ComponentID: 30,
        SectionID: 'PreTrade',
        Name: 'MarketDataSnapshotFullRefresh',
    },
    {
        CategoryID: 'MarketData',
        Description:
            'The Market Data message for incremental updates may contain any combination of new, changed, or deleted Market Data Entries, for any combination of instruments, with any combination of trades, imbalances, quotes, index values, open, close, settlement, high, low, and VWAP prices, trade volume and open interest so long as the maximum FIX message size is not exceeded. All of these types of Market Data Entries can be changed and deleted.',
        added: 'FIX.4.2',
        AbbrName: 'MktDataInc',
        MsgType: 'X',
        NotReqXML: 0,
        ComponentID: 31,
        SectionID: 'PreTrade',
        Name: 'MarketDataIncrementalRefresh',
    },
    {
        CategoryID: 'MarketData',
        Description:
            'The Market Data Request Reject is used when the broker cannot honor the Market Data Request, due to business or technical reasons. Brokers may choose to limit various parameters, such as the size of requests, whether just the top of book or the entire book may be displayed, and whether Full or Incremental updates must be used.',
        added: 'FIX.4.2',
        AbbrName: 'MktDataReqRej',
        MsgType: 'Y',
        NotReqXML: 0,
        ComponentID: 32,
        SectionID: 'PreTrade',
        Name: 'MarketDataRequestReject',
    },
    {
        CategoryID: 'QuotationNegotiation',
        Description:
            'The Quote Cancel message is used by an originator of quotes to cancel quotes.\nThe Quote Cancel message supports cancellation of:\n• All quotes\n• Quotes for a specific symbol or security ID\n• All quotes for a security type\n• All quotes for an underlying',
        added: 'FIX.4.2',
        AbbrName: 'QuotCxl',
        MsgType: 'Z',
        NotReqXML: 0,
        ComponentID: 33,
        SectionID: 'PreTrade',
        Name: 'QuoteCancel',
    },
    {
        CategoryID: 'QuotationNegotiation',
        Description:
            'The quote status request message is used for the following purposes in markets that employ tradeable or restricted tradeable quotes:\n• For the issuer of a quote in a market to query the status of that quote (using the QuoteID to specify the target quote).\n• To subscribe and unsubscribe for Quote Status Report messages for one or more securities.',
        added: 'FIX.4.2',
        AbbrName: 'QuotStatReq',
        MsgType: 'a',
        NotReqXML: 0,
        ComponentID: 34,
        SectionID: 'PreTrade',
        Name: 'QuoteStatusRequest',
    },
    {
        CategoryID: 'QuotationNegotiation',
        Description: 'Mass Quote Acknowledgement is used as the application level response to a Mass Quote message.',
        added: 'FIX.4.2',
        AbbrName: 'MassQuotAck',
        MsgType: 'b',
        NotReqXML: 0,
        ComponentID: 35,
        SectionID: 'PreTrade',
        Name: 'MassQuoteAcknowledgement',
    },
    {
        CategoryID: 'SecuritiesReferenceData',
        Description:
            'The Security Definition Request message is used for the following:\n1. Request a specific Security to be traded with the second party. The request security can be defined as a multileg security made up of one or more instrument legs.\n2. Request a set of individual securities for a single market segment.\n3. Request all securities, independent of market segment.',
        added: 'FIX.4.2',
        updatedEP: 97,
        AbbrName: 'SecDefReq',
        MsgType: 'c',
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        ComponentID: 36,
        SectionID: 'PreTrade',
        Name: 'SecurityDefinitionRequest',
    },
    {
        CategoryID: 'SecuritiesReferenceData',
        Description:
            "The Security Definition message is used for the following:\n1. Accept the security defined in a Security Definition message.\n2. Accept the security defined in a Security Definition message with changes to the definition and/or identity of the security.\n3. Reject the security requested in a Security Definition message.\n4. Respond to a request for securities within a specified market segment.\n5. Convey comprehensive security definition for all market segments that the security participates in.\n6. Convey the security's trading rules that differ from default rules for the market segment.",
        added: 'FIX.4.2',
        updatedEP: 97,
        AbbrName: 'SecDef',
        MsgType: 'd',
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        ComponentID: 37,
        SectionID: 'PreTrade',
        Name: 'SecurityDefinition',
    },
    {
        CategoryID: 'SecuritiesReferenceData',
        Description:
            'The Security Status Request message provides for the ability to request the status of a security. One or more Security Status messages are returned as a result of a Security Status Request message.',
        added: 'FIX.4.2',
        updatedEP: 97,
        AbbrName: 'SecStatReq',
        MsgType: 'e',
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        ComponentID: 38,
        SectionID: 'PreTrade',
        Name: 'SecurityStatusRequest',
    },
    {
        CategoryID: 'SecuritiesReferenceData',
        Description:
            'The Security Status message provides for the ability to report changes in status to a security. The Security Status message contains fields to indicate trading status, corporate actions, financial status of the company. The Security Status message is used by one trading entity (for instance an exchange) to report changes in the state of a security.',
        added: 'FIX.4.2',
        updatedEP: 97,
        AbbrName: 'SecStat',
        MsgType: 'f',
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        ComponentID: 39,
        SectionID: 'PreTrade',
        Name: 'SecurityStatus',
    },
    {
        CategoryID: 'MarketStructureReferenceData',
        Description:
            'The Trading Session Status Request is used to request information on the status of a market. With the move to multiple sessions occurring for a given trading party (morning and evening sessions for instance) there is a need to be able to provide information on what product is trading on what market.',
        added: 'FIX.4.2',
        updatedEP: 97,
        AbbrName: 'TrdgSesStatReq',
        MsgType: 'g',
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        ComponentID: 40,
        SectionID: 'PreTrade',
        Name: 'TradingSessionStatusRequest',
    },
    {
        CategoryID: 'MarketStructureReferenceData',
        Description:
            'The Trading Session Status provides information on the status of a market. For markets multiple trading sessions on multiple-markets occurring (morning and evening sessions for instance), this message is able to provide information on what products are trading on what market during what trading session.',
        added: 'FIX.4.2',
        updatedEP: 97,
        AbbrName: 'TrdgSesStat',
        MsgType: 'h',
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        ComponentID: 41,
        SectionID: 'PreTrade',
        Name: 'TradingSessionStatus',
    },
    {
        CategoryID: 'QuotationNegotiation',
        Description:
            'The Mass Quote message can contain quotes for multiple securities to support applications that allow for the mass quoting of an option series. Two levels of repeating groups have been provided to minimize the amount of data required to submit a set of quotes for a class of options (e.g. all option series for IBM).',
        added: 'FIX.4.2',
        AbbrName: 'MassQuot',
        MsgType: 'i',
        NotReqXML: 0,
        ComponentID: 42,
        SectionID: 'PreTrade',
        Name: 'MassQuote',
    },
    {
        CategoryID: 'BusinessReject',
        Description:
            'The Business Message Reject message can reject an application-level message which fulfills session-level rules and cannot be rejected via any other means. Note if the message fails a session-level rule (e.g. body length is incorrect), a session-level Reject message should be issued.',
        added: 'FIX.4.2',
        AbbrName: 'BizMsgRej',
        MsgType: 'j',
        NotReqXML: 0,
        ComponentID: 43,
        SectionID: 'Infrastructure',
        Name: 'BusinessMessageReject',
    },
    {
        CategoryID: 'ProgramTrading',
        Description:
            'The BidRequest Message can be used in one of two ways depending on which market conventions are being followed.\n      In the "Non disclosed" convention (e.g. US/European model) the BidRequest message can be used to request a bid based on the sector, country, index and liquidity information contained within the message itself. In the "Non disclosed" convention the entry repeating group is used to define liquidity of the program. See " Program/Basket/List Trading"  for an example.\n      In the "Disclosed" convention (e.g. Japanese model) the BidRequest message can be used to request bids based on the ListOrderDetail messages sent in advance of BidRequest message. In the "Disclosed" convention the list repeating group is used to define which ListOrderDetail messages a bid is being sort for and the directions of the required bids.',
        added: 'FIX.4.2',
        AbbrName: 'BidReq',
        MsgType: 'k',
        NotReqXML: 0,
        ComponentID: 44,
        SectionID: 'Trade',
        Name: 'BidRequest',
    },
    {
        CategoryID: 'ProgramTrading',
        Description:
            'The Bid Response message can be used in one of two ways depending on which market conventions are being followed.\n      In the "Non disclosed" convention the Bid Response message can be used to supply a bid based on the sector, country, index and liquidity information contained within the corresponding bid request message. See "Program/Basket/List Trading"  for an example.\n      In the "Disclosed" convention the Bid Response message can be used to supply bids based on the List Order Detail messages sent in advance of the corresponding Bid Request message.',
        added: 'FIX.4.2',
        AbbrName: 'BidRsp',
        MsgType: 'l',
        NotReqXML: 0,
        ComponentID: 45,
        SectionID: 'Trade',
        Name: 'BidResponse',
    },
    {
        CategoryID: 'ProgramTrading',
        Description:
            'The strike price message is used to exchange strike price information for principal trades. It can also be used to exchange reference prices for agency trades.',
        added: 'FIX.4.2',
        AbbrName: 'ListStrkPx',
        MsgType: 'm',
        NotReqXML: 0,
        ComponentID: 46,
        SectionID: 'Trade',
        Name: 'ListStrikePrice',
    },
    {
        CategoryID: 'Session',
        Description: '',
        added: 'FIX.4.3',
        AbbrName: 'XMLnonFIX',
        MsgType: 'n',
        NotReqXML: 1,
        ComponentID: 47,
        SectionID: 'Session',
        Name: 'XMLnonFIX',
    },
    {
        CategoryID: 'RegistrationInstruction',
        Description:
            'The Registration Instructions message type may be used by institutions or retail intermediaries wishing to electronically submit registration information to a broker or fund manager (for CIV) for an order or for an allocation.',
        added: 'FIX.4.3',
        AbbrName: 'RgstInstrctns',
        MsgType: 'o',
        NotReqXML: 0,
        ComponentID: 48,
        SectionID: 'PostTrade',
        Name: 'RegistrationInstructions',
    },
    {
        CategoryID: 'RegistrationInstruction',
        Description:
            'The Registration Instructions Response message type may be used by broker or fund manager (for CIV) in response to a Registration Instructions message submitted by an institution or retail intermediary for an order or for an allocation.',
        added: 'FIX.4.3',
        AbbrName: 'RgstInstrctnsRsp',
        MsgType: 'p',
        NotReqXML: 0,
        ComponentID: 49,
        SectionID: 'PostTrade',
        Name: 'RegistrationInstructionsResponse',
    },
    {
        CategoryID: 'OrderMassHandling',
        Description:
            'The order mass cancel request message requests the cancellation of all of the remaining quantity of a group of orders matching criteria specified within the request. NOTE: This message can only be used to cancel order messages (reduce the full quantity).',
        added: 'FIX.4.3',
        AbbrName: 'OrdMassCxlReq',
        MsgType: 'q',
        NotReqXML: 0,
        ComponentID: 50,
        SectionID: 'Trade',
        Name: 'OrderMassCancelRequest',
    },
    {
        CategoryID: 'OrderMassHandling',
        Description:
            'The Order Mass Cancel Report is used to acknowledge an Order Mass Cancel Request. Note that each affected order that is canceled is acknowledged with a separate Execution Report or Order Cancel Reject message.',
        added: 'FIX.4.3',
        AbbrName: 'OrdMassCxlRpt',
        MsgType: 'r',
        NotReqXML: 0,
        ComponentID: 51,
        SectionID: 'Trade',
        Name: 'OrderMassCancelReport',
    },
    {
        CategoryID: 'CrossOrders',
        Description:
            'Used to submit a cross order into a market. The cross order contains two order sides (a buy and a sell). The cross order is identified by its CrossID.',
        added: 'FIX.4.3',
        AbbrName: 'NewOrdCrss',
        MsgType: 's',
        NotReqXML: 0,
        ComponentID: 52,
        SectionID: 'Trade',
        Name: 'NewOrderCross',
    },
    {
        CategoryID: 'CrossOrders',
        Description:
            'Used to modify a cross order previously submitted using the New Order - Cross message. See Order Cancel Replace Request for details concerning message usage.',
        added: 'FIX.4.3',
        AbbrName: 'CrssOrdCxlRplcReq',
        MsgType: 't',
        NotReqXML: 0,
        ComponentID: 53,
        SectionID: 'Trade',
        Name: 'CrossOrderCancelReplaceRequest',
    },
    {
        CategoryID: 'CrossOrders',
        Description: 'Used to fully cancel the remaining open quantity of a cross order.',
        added: 'FIX.4.3',
        AbbrName: 'CrssOrdCxlReq',
        MsgType: 'u',
        NotReqXML: 0,
        ComponentID: 54,
        SectionID: 'Trade',
        Name: 'CrossOrderCancelRequest',
    },
    {
        CategoryID: 'SecuritiesReferenceData',
        Description:
            'The Security Type Request message is used to return a list of security types available from a counterparty or market.',
        added: 'FIX.4.3',
        updatedEP: 97,
        AbbrName: 'SecTypReq',
        MsgType: 'v',
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        ComponentID: 55,
        SectionID: 'PreTrade',
        Name: 'SecurityTypeRequest',
    },
    {
        CategoryID: 'SecuritiesReferenceData',
        Description:
            'The Security Type Request message is used to return a list of security types available from a counterparty or market.',
        added: 'FIX.4.3',
        updatedEP: 97,
        AbbrName: 'SecTyps',
        MsgType: 'w',
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        ComponentID: 56,
        SectionID: 'PreTrade',
        Name: 'SecurityTypes',
    },
    {
        CategoryID: 'SecuritiesReferenceData',
        Description:
            'The Security List Request message is used to return a list of securities from the counterparty that match criteria provided on the request',
        added: 'FIX.4.3',
        updatedEP: 97,
        AbbrName: 'SecListReq',
        MsgType: 'x',
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        ComponentID: 57,
        SectionID: 'PreTrade',
        Name: 'SecurityListRequest',
    },
    {
        CategoryID: 'SecuritiesReferenceData',
        Description:
            'The Security List message is used to return a list of securities that matches the criteria specified in a Security List Request.',
        added: 'FIX.4.3',
        updatedEP: 97,
        AbbrName: 'SecList',
        MsgType: 'y',
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        ComponentID: 58,
        SectionID: 'PreTrade',
        Name: 'SecurityList',
    },
    {
        CategoryID: 'SecuritiesReferenceData',
        Description:
            'The Derivative Security List Request message is used to return a list of securities from the counterparty that match criteria provided on the request',
        added: 'FIX.4.3',
        updatedEP: 97,
        AbbrName: 'DerivSecListReq',
        MsgType: 'z',
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        ComponentID: 59,
        SectionID: 'PreTrade',
        Name: 'DerivativeSecurityListRequest',
    },
    {
        CategoryID: 'SecuritiesReferenceData',
        Description:
            'The Derivative Security List message is used to return a list of securities that matches the criteria specified in a Derivative Security List Request.',
        added: 'FIX.4.3',
        updatedEP: 97,
        AbbrName: 'DerivSecList',
        MsgType: 'AA',
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        ComponentID: 60,
        SectionID: 'PreTrade',
        Name: 'DerivativeSecurityList',
    },
    {
        CategoryID: 'MultilegOrders',
        Description:
            'The New Order - Multileg is provided to submit orders for securities that are made up of multiple securities, known as legs.',
        added: 'FIX.4.3',
        AbbrName: 'NewOrdMleg',
        MsgType: 'AB',
        NotReqXML: 0,
        ComponentID: 61,
        SectionID: 'Trade',
        Name: 'NewOrderMultileg',
    },
    {
        CategoryID: 'MultilegOrders',
        Description:
            'Used to modify a multileg order previously submitted using the New Order - Multileg message. See Order Cancel Replace Request for details concerning message usage.',
        added: 'FIX.4.3',
        AbbrName: 'MlegOrdCxlRplc',
        MsgType: 'AC',
        NotReqXML: 0,
        ComponentID: 62,
        SectionID: 'Trade',
        Name: 'MultilegOrderCancelReplace',
    },
    {
        CategoryID: 'TradeCapture',
        Description:
            'The Trade Capture Report Request can be used to:\n• Request one or more trade capture reports based upon selection criteria provided on the trade capture report request\n• Subscribe for trade capture reports based upon selection criteria provided on the trade capture report request.',
        added: 'FIX.4.3',
        AbbrName: 'TrdCaptRptReq',
        MsgType: 'AD',
        NotReqXML: 0,
        ComponentID: 63,
        SectionID: 'PostTrade',
        Name: 'TradeCaptureReportRequest',
    },
    {
        CategoryID: 'TradeCapture',
        Description:
            'The Trade Capture Report message can be:\n• Used to report trades between counterparties.\n• Used to report trades to a trade matching system\n• Can be sent unsolicited between counterparties.\n• Sent as a reply to a Trade Capture Report Request.\n• Can be used to report unmatched and matched trades.',
        added: 'FIX.4.3',
        AbbrName: 'TrdCaptRpt',
        MsgType: 'AE',
        NotReqXML: 0,
        ComponentID: 64,
        SectionID: 'PostTrade',
        Name: 'TradeCaptureReport',
    },
    {
        CategoryID: 'OrderMassHandling',
        Description:
            'The order mass status request message requests the status for orders matching criteria specified within the request.',
        added: 'FIX.4.3',
        AbbrName: 'OrdMassStatReq',
        MsgType: 'AF',
        NotReqXML: 0,
        ComponentID: 65,
        SectionID: 'Trade',
        Name: 'OrderMassStatusRequest',
    },
    {
        CategoryID: 'QuotationNegotiation',
        Description:
            'The Quote Request Reject message is used to reject Quote Request messages for all quoting models.',
        added: 'FIX.4.3',
        AbbrName: 'QuotReqRej',
        MsgType: 'AG',
        NotReqXML: 0,
        ComponentID: 66,
        SectionID: 'PreTrade',
        Name: 'QuoteRequestReject',
    },
    {
        CategoryID: 'QuotationNegotiation',
        Description:
            'In tradeable and restricted tradeable quoting markets – Quote Requests are issued by counterparties interested in ascertaining the market for an instrument. Quote Requests are then distributed by the market to liquidity providers who make markets in the instrument. The RFQ Request is used by liquidity providers to indicate to the market for which instruments they are interested in receiving Quote Requests. It can be used to register interest in receiving quote requests for a single instrument or for multiple instruments',
        added: 'FIX.4.3',
        AbbrName: 'RFQReq',
        MsgType: 'AH',
        NotReqXML: 0,
        ComponentID: 67,
        SectionID: 'PreTrade',
        Name: 'RFQRequest',
    },
    {
        CategoryID: 'QuotationNegotiation',
        Description:
            'The quote status report message is used:\n• as the response to a Quote Status Request message\n• as a response to a Quote Cancel message\n• as a response to a Quote Response message in a negotiation dialog (see Volume 7 – PRODUCT: FIXED INCOME and USER GROUP: EXCHANGES AND MARKETS)',
        added: 'FIX.4.3',
        AbbrName: 'QuotStatRpt',
        MsgType: 'AI',
        NotReqXML: 0,
        ComponentID: 68,
        SectionID: 'PreTrade',
        Name: 'QuoteStatusReport',
    },
    {
        CategoryID: 'QuotationNegotiation',
        Description:
            'The Quote Response message is used to respond to a IOI message or Quote message. It is also used to counter a Quote or end a negotiation dialog.',
        added: 'FIX.4.4',
        AbbrName: 'QuotRsp',
        MsgType: 'AJ',
        NotReqXML: 0,
        ComponentID: 69,
        SectionID: 'PreTrade',
        Name: 'QuoteResponse',
    },
    {
        CategoryID: 'Confirmation',
        Description:
            'The Confirmation messages are used to provide individual trade level confirmations from the sell side to the buy side. In versions of FIX prior to version 4.4, this role was performed by the allocation message. Unlike the allocation message, the confirmation message operates at an allocation account (trade) level rather than block level, allowing for the affirmation or rejection of individual confirmations.',
        added: 'FIX.4.4',
        AbbrName: 'Cnfm',
        MsgType: 'AK',
        NotReqXML: 0,
        ComponentID: 70,
        SectionID: 'PostTrade',
        Name: 'Confirmation',
    },
    {
        CategoryID: 'PositionMaintenance',
        Description:
            'The Position Maintenance Request message allows the position owner to submit requests to the holder of a position which will result in a specific action being taken which will affect the position. Generally, the holder of the position is a central counter party or clearing organization but can also be a party providing investment services.',
        added: 'FIX.4.4',
        AbbrName: 'PosMntReq',
        MsgType: 'AL',
        NotReqXML: 0,
        ComponentID: 71,
        SectionID: 'PostTrade',
        Name: 'PositionMaintenanceRequest',
    },
    {
        CategoryID: 'PositionMaintenance',
        Description:
            'The Position Maintenance Report message is sent by the holder of a positon in response to a Position Maintenance Request and is used to confirm that a request has been successfully processed or rejected.',
        added: 'FIX.4.4',
        AbbrName: 'PosMntRpt',
        MsgType: 'AM',
        NotReqXML: 0,
        ComponentID: 72,
        SectionID: 'PostTrade',
        Name: 'PositionMaintenanceReport',
    },
    {
        CategoryID: 'PositionMaintenance',
        Description:
            'The Request For Positions message is used by the owner of a position to request a Position Report from the holder of the position, usually the central counter party or clearing organization. The request can be made at several levels of granularity.',
        added: 'FIX.4.4',
        AbbrName: 'ReqForPoss',
        MsgType: 'AN',
        NotReqXML: 0,
        ComponentID: 73,
        SectionID: 'PostTrade',
        Name: 'RequestForPositions',
    },
    {
        CategoryID: 'PositionMaintenance',
        Description:
            'The Request for Positions Ack message is returned by the holder of the position in response to a Request for Positions message. The purpose of the message is to acknowledge that a request has been received and is being processed.',
        added: 'FIX.4.4',
        AbbrName: 'ReqForPossAck',
        MsgType: 'AO',
        NotReqXML: 0,
        ComponentID: 74,
        SectionID: 'PostTrade',
        Name: 'RequestForPositionsAck',
    },
    {
        CategoryID: 'PositionMaintenance',
        Description:
            'The Position Report message is returned by the holder of a position in response to a Request for Position message. The purpose of the message is to report all aspects of a position and may be provided on a standing basis to report end of day positions to an owner.',
        added: 'FIX.4.4',
        AbbrName: 'PosRpt',
        MsgType: 'AP',
        NotReqXML: 0,
        ComponentID: 75,
        SectionID: 'PostTrade',
        Name: 'PositionReport',
    },
    {
        CategoryID: 'TradeCapture',
        Description:
            'The Trade Capture Request Ack message is used to:\n• Provide an acknowledgement to a Trade Capture Report Request in the case where the Trade Capture Report Request is used to specify a subscription or delivery of reports via an out-of-band ResponseTransmissionMethod.\n• Provide an acknowledgement to a Trade Capture Report Request in the case when the return of the Trade Capture Reports matching that request will be delayed or delivered asynchronously. This is useful in distributed trading system environments.\n• Indicate that no trades were found that matched the selection criteria specified on the Trade Capture Report Request\n• The Trade Capture Request was invalid for some business reason, such as request is not authorized, invalid or unknown instrument, party, trading session, etc.',
        added: 'FIX.4.4',
        AbbrName: 'TrdCaptRptReqAck',
        MsgType: 'AQ',
        NotReqXML: 0,
        ComponentID: 76,
        SectionID: 'PostTrade',
        Name: 'TradeCaptureReportRequestAck',
    },
    {
        CategoryID: 'TradeCapture',
        Description:
            'The Trade Capture Report Ack message can be:\n• Used to acknowledge trade capture reports received from a counterparty\n• Used to reject a trade capture report received from a counterparty',
        added: 'FIX.4.4',
        AbbrName: 'TrdCaptRptAck',
        MsgType: 'AR',
        NotReqXML: 0,
        ComponentID: 77,
        SectionID: 'PostTrade',
        Name: 'TradeCaptureReportAck',
    },
    {
        CategoryID: 'Allocation',
        Description:
            'Sent from sell-side to buy-side, sell-side to 3rd-party or 3rd-party to buy-side, the Allocation Report (Claim) provides account breakdown of an order or set of orders plus any additional follow-up front-office information developed post-trade during the trade allocation, matching and calculation phase. In versions of FIX prior to version 4.4, this functionality was provided through the Allocation message. Depending on the needs of the market and the timing of "confirmed" status, the role of Allocation Report can be taken over in whole or in part by the Confirmation message.',
        added: 'FIX.4.4',
        AbbrName: 'AllocRpt',
        MsgType: 'AS',
        NotReqXML: 0,
        ComponentID: 78,
        SectionID: 'PostTrade',
        Name: 'AllocationReport',
    },
    {
        CategoryID: 'Allocation',
        Description:
            'The Allocation Report Ack message is used to acknowledge the receipt of and provide status for an Allocation Report message.',
        added: 'FIX.4.4',
        AbbrName: 'AllocRptAck',
        MsgType: 'AT',
        NotReqXML: 0,
        ComponentID: 79,
        SectionID: 'PostTrade',
        Name: 'AllocationReportAck',
    },
    {
        CategoryID: 'Confirmation',
        Description: 'The Confirmation Ack (aka Affirmation) message is used to respond to a Confirmation message.',
        added: 'FIX.4.4',
        AbbrName: 'CnfmAck',
        MsgType: 'AU',
        NotReqXML: 0,
        ComponentID: 80,
        SectionID: 'PostTrade',
        Name: 'ConfirmationAck',
    },
    {
        CategoryID: 'SettlementInstruction',
        Description:
            'The Settlement Instruction Request message is used to request standing settlement instructions from another party.',
        added: 'FIX.4.4',
        AbbrName: 'SettlInstrctnReq',
        MsgType: 'AV',
        NotReqXML: 0,
        ComponentID: 81,
        SectionID: 'PostTrade',
        Name: 'SettlementInstructionRequest',
    },
    {
        CategoryID: 'PositionMaintenance',
        Description:
            'Assignment Reports are sent from a clearing house to counterparties, such as a clearing firm as a result of the assignment process.',
        added: 'FIX.4.4',
        AbbrName: 'AsgnRpt',
        MsgType: 'AW',
        NotReqXML: 0,
        ComponentID: 82,
        SectionID: 'PostTrade',
        Name: 'AssignmentReport',
    },
    {
        CategoryID: 'CollateralManagement',
        Description:
            'An initiator that requires collateral from a respondent sends a Collateral Request. The initiator can be either counterparty to a trade in a two party model or an intermediary such as an ATS or clearinghouse in a three party model. A Collateral Assignment is expected as a response to a request for collateral.',
        added: 'FIX.4.4',
        AbbrName: 'CollReq',
        MsgType: 'AX',
        NotReqXML: 0,
        ComponentID: 83,
        SectionID: 'PostTrade',
        Name: 'CollateralRequest',
    },
    {
        CategoryID: 'CollateralManagement',
        Description:
            'Used to assign collateral to cover a trading position. This message can be sent unsolicited or in reply to a Collateral Request message.',
        added: 'FIX.4.4',
        AbbrName: 'CollAsgn',
        MsgType: 'AY',
        NotReqXML: 0,
        ComponentID: 84,
        SectionID: 'PostTrade',
        Name: 'CollateralAssignment',
    },
    {
        CategoryID: 'CollateralManagement',
        Description: 'Used to respond to a Collateral Assignment message.',
        added: 'FIX.4.4',
        AbbrName: 'CollRsp',
        MsgType: 'AZ',
        NotReqXML: 0,
        ComponentID: 85,
        SectionID: 'PostTrade',
        Name: 'CollateralResponse',
    },
    {
        CategoryID: 'CollateralManagement',
        Description: 'Used to report collateral status when responding to a Collateral Inquiry message.',
        added: 'FIX.4.4',
        AbbrName: 'CollRpt',
        MsgType: 'BA',
        NotReqXML: 0,
        ComponentID: 86,
        SectionID: 'PostTrade',
        Name: 'CollateralReport',
    },
    {
        CategoryID: 'CollateralManagement',
        Description: 'Used to inquire for collateral status.',
        added: 'FIX.4.4',
        AbbrName: 'CollInq',
        MsgType: 'BB',
        NotReqXML: 0,
        ComponentID: 87,
        SectionID: 'PostTrade',
        Name: 'CollateralInquiry',
    },
    {
        CategoryID: 'Network',
        Description:
            'This message is send either immediately after logging on to inform a network (counterparty system) of the type of updates required or to at any other time in the FIX conversation to change the nature of the types of status updates required. It can also be used with a NetworkRequestType of Snapshot to request a one-off report of the status of a network (or counterparty) system. Finally this message can also be used to cancel a request to receive updates into the status of the counterparties on a network by sending a NetworkRequestStatusMessage with a NetworkRequestType of StopSubscribing.',
        added: 'FIX.4.4',
        AbbrName: 'NtwkSysStatReq',
        MsgType: 'BC',
        NotReqXML: 0,
        ComponentID: 88,
        SectionID: 'Infrastructure',
        Name: 'NetworkCounterpartySystemStatusRequest',
    },
    {
        CategoryID: 'Network',
        Description: 'This message is sent in response to a Network (Counterparty System) Status Request Message.',
        added: 'FIX.4.4',
        AbbrName: 'NtwkSysStatRsp',
        MsgType: 'BD',
        NotReqXML: 0,
        ComponentID: 89,
        SectionID: 'Infrastructure',
        Name: 'NetworkCounterpartySystemStatusResponse',
    },
    {
        CategoryID: 'UserManagement',
        Description:
            "This message is used to initiate a user action, logon, logout or password change. It can also be used to request a report on a user's status.",
        added: 'FIX.4.4',
        AbbrName: 'UserReq',
        MsgType: 'BE',
        NotReqXML: 0,
        ComponentID: 90,
        SectionID: 'Infrastructure',
        Name: 'UserRequest',
    },
    {
        CategoryID: 'UserManagement',
        Description:
            'This message is used to respond to a user request message, it reports the status of the user after the completion of any action requested in the user request message.',
        added: 'FIX.4.4',
        AbbrName: 'UserRsp',
        MsgType: 'BF',
        NotReqXML: 0,
        ComponentID: 91,
        SectionID: 'Infrastructure',
        Name: 'UserResponse',
    },
    {
        CategoryID: 'CollateralManagement',
        Description:
            'Used to respond to a Collateral Inquiry in the following situations:\n• When the CollateralInquiry will result in an out of band response (such as a file transfer).\n• When the inquiry is otherwise valid but no collateral is found to match the criteria specified on the Collateral Inquiry message.\n• When the Collateral Inquiry is invalid based upon the business rules of the counterparty.',
        added: 'FIX.4.4',
        AbbrName: 'CollInqAck',
        MsgType: 'BG',
        NotReqXML: 0,
        ComponentID: 92,
        SectionID: 'PostTrade',
        Name: 'CollateralInquiryAck',
    },
    {
        CategoryID: 'Confirmation',
        Description: 'The Confirmation Request message is used to request a Confirmation message.',
        added: 'FIX.4.4',
        AbbrName: 'CnfmReq',
        MsgType: 'BH',
        NotReqXML: 0,
        ComponentID: 93,
        SectionID: 'PostTrade',
        Name: 'ConfirmationRequest',
    },
    {
        CategoryID: 'PositionMaintenance',
        Description:
            'The Contrary Intention Report is used for reporting of contrary expiration quantities for Saturday expiring options. This information is required by options exchanges for regulatory purposes.',
        added: 'FIX.4.4',
        AbbrName: 'ContIntRpt',
        addedEP: -1,
        MsgType: 'BO',
        NotReqXML: 0,
        ComponentID: 94,
        SectionID: 'PostTrade',
        Name: 'ContraryIntentionReport',
    },
    {
        CategoryID: 'SecuritiesReferenceData',
        Description:
            'This message is used for reporting updates to a Product Security Masterfile. Updates could be the result of corporate actions or other business events. Updates may include additions, modifications or deletions.',
        added: 'FIX.4.4',
        updatedEP: 97,
        AbbrName: 'SecDefUpd',
        addedEP: -1,
        MsgType: 'BP',
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        ComponentID: 95,
        SectionID: 'PreTrade',
        Name: 'SecurityDefinitionUpdateReport',
    },
    {
        CategoryID: 'SecuritiesReferenceData',
        Description:
            'The Security List Update Report is used for reporting updates to a Contract Security Masterfile. Updates could be due to Corporate Actions or other business events. Update may include additions, modifications and deletions.',
        added: 'FIX.4.4',
        updatedEP: 97,
        AbbrName: 'SecListUpd',
        addedEP: -1,
        MsgType: 'BK',
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        ComponentID: 96,
        SectionID: 'PreTrade',
        Name: 'SecurityListUpdateReport',
    },
    {
        CategoryID: 'PositionMaintenance',
        Description:
            'Used to report changes in position, primarily in equity options, due to modifications to the underlying due to corporate actions',
        added: 'FIX.4.4',
        AbbrName: 'AdjPosRep',
        addedEP: -1,
        MsgType: 'BL',
        NotReqXML: 0,
        ComponentID: 97,
        SectionID: 'PostTrade',
        Name: 'AdjustedPositionReport',
    },
    {
        CategoryID: 'Allocation',
        Description:
            'This message is used in a 3-party allocation model where notification of group creation and group updates to counterparties is needed. The mssage will also carry trade information that comprised the group to the counterparties.',
        added: 'FIX.4.4',
        AbbrName: 'AllocInstrAlert',
        addedEP: -1,
        MsgType: 'BM',
        NotReqXML: 0,
        ComponentID: 98,
        SectionID: 'PostTrade',
        Name: 'AllocationInstructionAlert',
    },
    {
        CategoryID: 'SingleGeneralOrderHandling',
        Description:
            "The Execution Report Acknowledgement message is an optional message that provides dual functionality to notify a trading partner that an electronically received execution has either been accepted or rejected (DK'd).",
        added: 'FIX.4.4',
        AbbrName: 'ExecAck',
        addedEP: -1,
        MsgType: 'BN',
        NotReqXML: 0,
        ComponentID: 99,
        SectionID: 'Trade',
        Name: 'ExecutionAcknowledgement',
    },
    {
        CategoryID: 'MarketStructureReferenceData',
        Description:
            'The Trading Session List message is sent as a response to a Trading Session List Request. The Trading Session List should contain the characteristics of the trading session and the current state of the trading session.',
        added: 'FIX.4.4',
        updatedEP: 97,
        AbbrName: 'TradSessList',
        addedEP: -1,
        MsgType: 'BJ',
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        ComponentID: 100,
        SectionID: 'PreTrade',
        Name: 'TradingSessionList',
    },
    {
        CategoryID: 'MarketStructureReferenceData',
        Description:
            'The Trading Session List Request is used to request a list of trading sessions available in a market place and the state of those trading sessions. A successful request will result in a response from the counterparty of a Trading Session List (MsgType=BJ) message that contains a list of zero or more trading sessions.',
        added: 'FIX.4.4',
        updatedEP: 97,
        AbbrName: 'TradSessListReq',
        addedEP: -1,
        MsgType: 'BI',
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        ComponentID: 101,
        SectionID: 'PreTrade',
        Name: 'TradingSessionListRequest',
    },
    {
        CategoryID: 'SettlementInstruction',
        Description:
            'The Settlement Obligation Report message provides a central counterparty, institution, or individual counterparty with a capacity for reporting the final details of a currency settlement obligation.',
        added: 'FIX.5.0',
        AbbrName: 'SettlObligation',
        addedEP: -1,
        MsgType: 'BQ',
        NotReqXML: 0,
        ComponentID: 102,
        SectionID: 'PostTrade',
        Name: 'SettlementObligationReport',
    },
    {
        CategoryID: 'SecuritiesReferenceData',
        Description:
            'The Derivative Security List Update Report message is used to send updates to an option family or the strikes that comprise an option family.',
        added: 'FIX.5.0',
        updatedEP: 97,
        AbbrName: 'DerivSecListUpd',
        addedEP: -1,
        MsgType: 'BR',
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        ComponentID: 103,
        SectionID: 'PreTrade',
        Name: 'DerivativeSecurityListUpdateReport',
    },
    {
        CategoryID: 'MarketStructureReferenceData',
        Description:
            'The Trading Session List Update Report is used by marketplaces to provide intra-day updates of trading sessions when there are changes to one or more trading sessions.',
        added: 'FIX.5.0',
        updatedEP: 97,
        AbbrName: 'TrdgSesListUpd',
        addedEP: -1,
        MsgType: 'BS',
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        ComponentID: 104,
        SectionID: 'PreTrade',
        Name: 'TradingSessionListUpdateReport',
    },
    {
        CategoryID: 'MarketStructureReferenceData',
        Description:
            'The Market Definition Request message is used to request for market structure information from the Respondent that receives this request.',
        added: 'FIX.5.0',
        updatedEP: 97,
        AbbrName: 'MktDefReq',
        addedEP: -1,
        MsgType: 'BT',
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        ComponentID: 105,
        SectionID: 'PreTrade',
        Name: 'MarketDefinitionRequest',
    },
    {
        CategoryID: 'MarketStructureReferenceData',
        Description:
            'The Market Definition message is used to respond to Market Definition Request. In a subscription, it will be used to provide the initial snapshot of the information requested. Subsequent updates are provided by the Market Definition Update Report.',
        added: 'FIX.5.0',
        updatedEP: 97,
        AbbrName: 'MktDef',
        addedEP: -1,
        MsgType: 'BU',
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        ComponentID: 106,
        SectionID: 'PreTrade',
        Name: 'MarketDefinition',
    },
    {
        CategoryID: 'MarketStructureReferenceData',
        Description:
            'In a subscription for market structure information, this message is used once the initial snapshot of the information has been sent using the Market Definition message.',
        added: 'FIX.5.0',
        updatedEP: 97,
        AbbrName: 'MktDefUpd',
        addedEP: -1,
        MsgType: 'BV',
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        ComponentID: 107,
        SectionID: 'PreTrade',
        Name: 'MarketDefinitionUpdateReport',
    },
    {
        CategoryID: 'UserManagement',
        Description:
            'The User Notification message is used to notify one or more users of an event or information from the sender of the message. This message is usually sent unsolicited from a marketplace (e.g. Exchange, ECN) to a market participant.',
        added: 'FIX.5.0',
        AbbrName: 'UserNotifctn',
        addedEP: -1,
        MsgType: 'CB',
        NotReqXML: 0,
        ComponentID: 113,
        SectionID: 'Infrastructure',
        Name: 'UserNotification',
    },
    {
        CategoryID: 'OrderMassHandling',
        Description:
            'The Order Mass Action Report is used to acknowledge an Order Mass Action Request. Note that each affected order that is suspended or released or canceled is acknowledged with a separate Execution Report for each order.',
        added: 'FIX.5.0',
        AbbrName: 'OrdMassActRpt',
        addedEP: -1,
        MsgType: 'BZ',
        NotReqXML: 0,
        ComponentID: 111,
        SectionID: 'Trade',
        Name: 'OrderMassActionReport',
    },
    {
        CategoryID: 'OrderMassHandling',
        Description:
            'The Order Mass Action Request message can be used to request the suspension or release of a group of orders that match the criteria specified within the request. This is equivalent to individual Order Cancel Replace Requests for each order with or without adding "S" to the ExecInst values. It can also be used for mass order cancellation.',
        added: 'FIX.5.0',
        AbbrName: 'OrdMassActReq',
        addedEP: -1,
        MsgType: 'CA',
        NotReqXML: 0,
        ComponentID: 112,
        SectionID: 'Trade',
        Name: 'OrderMassActionRequest',
    },
    {
        CategoryID: 'Application',
        Description:
            'This message is used to request a retransmission of a set of one or more messages generated by the application specified in RefApplID (1355).',
        added: 'FIX.5.0',
        AbbrName: 'ApplMsgReq',
        addedEP: -1,
        MsgType: 'BW',
        NotReqXML: 0,
        ComponentID: 108,
        SectionID: 'Infrastructure',
        Name: 'ApplicationMessageRequest',
    },
    {
        CategoryID: 'Application',
        Description:
            'This message is used to acknowledge an Application Message Request providing a status on the request (i.e. whether successful or not). This message does not provide the actual content of the messages to be resent.',
        added: 'FIX.5.0',
        AbbrName: 'ApplMsgReqAck',
        addedEP: -1,
        MsgType: 'BX',
        NotReqXML: 0,
        ComponentID: 109,
        SectionID: 'Infrastructure',
        Name: 'ApplicationMessageRequestAck',
    },
    {
        CategoryID: 'Application',
        Description:
            'This message is used for three difference purposes: to reset the ApplSeqNum (1181) of a specified ApplID (1180). to indicate that the last message has been sent for a particular ApplID, or as a keep-alive mechanism for ApplIDs with infrequent message traffic.',
        added: 'FIX.5.0',
        AbbrName: 'ApplMsgRpt',
        addedEP: -1,
        MsgType: 'BY',
        NotReqXML: 0,
        ComponentID: 110,
        SectionID: 'Infrastructure',
        Name: 'ApplicationMessageReport',
    },
    {
        CategoryID: 'MarketData',
        Description:
            'In certain markets where market data aggregators fan out to end clients the pricing streams provided by the price makers, the price maker may assign the clients to certain pricing streams that the price maker publishes via the aggregator. An example of this use is in the FX markets where clients may be assigned to different pricing streams based on volume bands and currency pairs.',
        added: 'FIX.5.0SP1',
        AbbrName: 'StrmAsgnReq',
        addedEP: 93,
        MsgType: 'CC',
        NotReqXML: 0,
        ComponentID: 114,
        SectionID: 'PreTrade',
        Name: 'StreamAssignmentRequest',
    },
    {
        CategoryID: 'MarketData',
        Description:
            'he StreamAssignmentReport message is in response to the StreamAssignmentRequest message. It provides information back to the aggregator as to which clients to assign to receive which price stream based on requested CCY pair. This message can be sent unsolicited to the Aggregator from the Price Maker.',
        added: 'FIX.5.0SP1',
        AbbrName: 'StrmAsgnRpt',
        addedEP: 93,
        MsgType: 'CD',
        NotReqXML: 0,
        ComponentID: 115,
        SectionID: 'PreTrade',
        Name: 'StreamAssignmentReport',
    },
    {
        CategoryID: 'MarketData',
        Description:
            'This message is used to respond to the Stream Assignment Report, to either accept or reject an unsolicited assingment.',
        added: 'FIX.5.0SP1',
        AbbrName: 'StrmAsgnRptACK',
        addedEP: 93,
        MsgType: 'CE',
        NotReqXML: 0,
        ComponentID: 116,
        SectionID: 'PreTrade',
        Name: 'StreamAssignmentReportACK',
    },
];
